import { render, staticRenderFns } from "./_BroadcastListPlaceholder.vue?vue&type=template&id=4cbb518e&scoped=true&"
import script from "./_BroadcastListPlaceholder.vue?vue&type=script&lang=js&"
export * from "./_BroadcastListPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./_BroadcastListPlaceholder.vue?vue&type=style&index=0&id=4cbb518e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbb518e",
  null
  
)

export default component.exports